import { BOM_VALIDATION_IN_PROGRESS, BOM_VALIDATION_FAILED } from '@/constants'

export function isValidationAvailable(status) {
  return !(!status || status === BOM_VALIDATION_IN_PROGRESS || status === BOM_VALIDATION_FAILED)
}
